import { render, staticRenderFns } from "./printerItem.vue?vue&type=template&id=578bf32a"
import script from "./printerItem.vue?vue&type=script&lang=js"
export * from "./printerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports